module.exports = __webpack_public_path__ + "img/上海占瑞.ec0d5434.jpg";